// push-order-20261021 / drawer-labels-20261021: drawer tab at the bottom of
// WalletHoldings to pick the armed order (long-press BUY) and its settings.
//
// Orders are plain entries so new ones (incl. Grok-made later) plug in the
// same way: { id, label, desc, settings: [{ label, min, max, step, get, set }] }
// get(cfg) reads the value; set(v) returns the patch for update(); chip(v)
// is the compact text shown in the BUY picker. (drawer-remove-20261021: the
// drawer itself is no longer rendered; ORDERS is still the source of truth.)
import { memo } from 'react'

export const ORDERS = [
  {
    id: 'liq',
    label: 'Liq reaction',
    desc: 'Buys when liquidity reacts fast',
    settings: [
      { label: 'Seconds', min: 1, max: 10, step: 0.5, get: (c) => c.liqSecs, set: (v) => ({ liqSecs: v }), chip: (v) => `${v}s` },
    ],
  },
  {
    id: 'push',
    label: 'Push',
    desc: "Buys now. Once price is up your target %, sells your sell % into big buys until you're back to breakeven. Never sells under breakeven. Keeps the rest free.",
    settings: [
      { label: 'Max buy SOL', min: 0.001, step: 0.1, get: (c) => c.push.maxSol, set: (v) => ({ push: { maxSol: v } }), chip: (v) => `max ${v}` },
      { label: 'Target %', min: 0, max: 1000, step: 10, get: (c) => c.push.target, set: (v) => ({ push: { target: v } }), chip: (v) => `+${v}%` },   // push-target-20261022
    ],
  },
]

function OrderEntryDrawer({ cfg, update, push }) {
  const st = push?.status
  const sel = ORDERS.find(o => o.id === cfg.type) || ORDERS[0]
  return (
    <div className="oe-drawer" onMouseDown={(e) => e.stopPropagation()} onDoubleClick={(e) => e.stopPropagation()}>
      <button className="oe-tab" onClick={() => update({ drawerOpen: !cfg.drawerOpen })}
        title="Order used by long-press BUY">
        <span>{cfg.drawerOpen ? 'v' : '^'} ORDER: {sel.label}</span>
        {st && <span className={`oe-st oe-${st.phase}`}>{st.text}</span>}
      </button>
      {cfg.drawerOpen && (
        <div className="oe-body">
          {ORDERS.map(o => {
            const on = o.id === sel.id
            return (
              <div key={o.id} className={`oe-item ${on ? 'on' : ''}`} onClick={() => !on && update({ type: o.id })}>
                <div className="oe-label">{o.label}</div>
                <div className="oe-desc">{o.desc}</div>
                {on && o.settings.slice(0, 2).map(s => (
                  <label key={s.label} className="oe-row" onClick={(e) => e.stopPropagation()}>
                    <span>{s.label}</span>
                    <input type="number" inputMode="decimal" step={s.step} min={s.min} max={s.max}
                      value={s.get(cfg)}
                      onChange={(e) => { const v = parseFloat(e.target.value); if (Number.isFinite(v)) update(s.set(v)) }} />
                  </label>
                ))}
              </div>
            )
          })}
          {st && (
            <div className="oe-status">
              <span className={`oe-st oe-${st.phase}`}>{st.text}</span>
              {st.phase !== 'done'
                ? <button onClick={push.cancel}>Cancel</button>
                : <button onClick={push.clear}>OK</button>}
            </div>
          )}
        </div>
      )}
      <style>{`
        .oe-drawer { border-top: 1px solid #2a2a35; font-size: 10px; color: #999; }
        .oe-tab { width: 100%; display: flex; justify-content: space-between; gap: 6px; background: #15151b; color: #888;
          border: 0; padding: 3px 8px; font-size: 9px; letter-spacing: 0.06em; cursor: pointer; text-align: left; }
        .oe-tab:hover { color: #bbb; }
        .oe-body { padding: 4px 6px 6px; display: flex; flex-direction: column; gap: 3px; }
        .oe-item { border: 1px solid #26262e; border-radius: 3px; padding: 3px 6px; cursor: pointer; }
        .oe-item:hover { border-color: #33333d; }
        .oe-item.on { border-color: #5a4200; background: #1a1608; cursor: default; }
        .oe-label { color: #aaa; font-weight: 600; }
        .oe-item.on .oe-label { color: #ffb300; }
        .oe-desc { color: #666; font-size: 9px; line-height: 1.3; }
        .oe-row { display: flex; justify-content: space-between; align-items: center; gap: 6px; margin-top: 3px; }
        .oe-row input { width: 60px; background: #111; color: #ddd; border: 1px solid #33333d; border-radius: 3px; padding: 1px 4px; font-size: 10px; }
        .oe-status { display: flex; justify-content: space-between; align-items: center; gap: 6px; margin-top: 2px; }
        .oe-status button { background: #1c1c24; color: #888; border: 1px solid #33333d; border-radius: 3px; padding: 1px 6px; font-size: 10px; cursor: pointer; }
        .oe-st { color: #ffb300; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
        .oe-st.oe-selling { color: #00ff77; } .oe-st.oe-done { color: #888; }
      `}</style>
    </div>
  )
}
export default memo(OrderEntryDrawer)
